'use client';

import Image from 'next/image';

import Button from '@/components/Button';
import CommonBreadcrumbs from '@/components/CommonBreadcrumbs';
import classes from './affiliateProgramPage.module.css';

const paths = [
  {
    text: 'Home',
    path: '/',
  },
  {
    text: 'Affiliate Program',
    path: '/affiliate-program',
    current: true,
  },
];

const AffiliateProgramPage = () => {
  return (
    <div className={classes.root}>
      <Image
        src='/images/affiliate-program/banner-m.webp'
        width={375}
        height={200}
        className='block h-auto w-full lg_hidden'
        alt=''
        unoptimized
        priority
      />
      <Image
        src='/images/affiliate-program/banner.webp'
        width={1920}
        height={370}
        className='hidden h-auto w-full lg_block'
        alt=''
        unoptimized
        priority
      />
      <div className='block bg-[#EFEFEF] p-[20px] lg_hidden'>
        <p className='font-poppins text-[30px] font-[700] uppercase text-title'>SHARE YOUR LOVE FOR BIRDS, AND EARN </p>
        <p className='mt-[10px] font-sans text-title'>
          Join our Affiliate Program and get rewarded for spreading the word about Kingsyard’s bird-friendly
          innovations.
        </p>
      </div>{' '}
      <div className={classes.contentContainer}>
        <CommonBreadcrumbs paths={paths} />
        <div className={classes.content}>
          <h1 className={classes.title}>kingsyard Affiliate Program</h1>
          <p className='font-normal text-title'>
            Kingsyard has been consistently focused on research and development of bird feeder-related products, since
            our founding in 2012, is looking forward to sharing our resources with you. Wanna earn some commissions on
            all referred sales by just referring customers and friends? Join our affiliate program to achieve a win-win
            situation!
          </p>

          <h2 className={classes.subtitle}>HOW IT WORKS</h2>
          <ul className={classes.text}>
            <li className={classes.textItem}>
              Apply for our Affiliate Program on AWIN, if you are already there, our ID is 79354. If you are not there
              yet, click the button below to sign up and join our affiliate program.
            </li>
            <li className={classes.textItem}>The affiliate promotes kingsyard on social platforms</li>
            <li className={classes.textItem}>The potential customer clicks on the posts</li>
            <li className={classes.textItem}>Customer orders at kingsyard.com</li>
            <li className={classes.textItem}>Affiliate receives commissions</li>
          </ul>

          <h2 className={classes.subtitle}>YOUR BENEFITS</h2>
          <ul className={classes.text}>
            <li className={classes.textItem}>Up to 20% commission rate on each referred sale.</li>
            <li className={classes.textItem}>Extra monthly Cash Bonus by sharing promotions</li>
            <li className={classes.textItem}>New monthly profitable activities , updating banners and coupons</li>
            <li className={classes.textItem}>Newsletters for the update on new activities and promotions</li>
          </ul>

          <h2 className={classes.subtitle}>YOUR CUSTOMERS BENEFITS</h2>

          <ul className={classes.text}>
            <li className={classes.textItem}>High quality pet supplies </li>
            <li className={classes.textItem}>Affordable prices </li>
            <li className={classes.textItem}>7/24 customer service and Live chat service </li>
            <li className={classes.textItem}>No-Questions-Asked Return and Refund</li>
          </ul>

          <div className={classes.buttonContainer}>
            <Button
              className={classes.button}
              onClick={() => {
                const link =
                  'https://ui.awin.com/express-signup/en/awin/79354/15306da0-9035-4e66-b351-9978d79b187c?t=Wgc0-4Ry6EAKaleIBeCgsEY4xBAPtGj24YZvTylMngQ';

                window.open(link, '_blank');
              }}
            >
              JOIN NOW
            </Button>
          </div>

          <p className={classes.contactUs}>
            If you have any other inquiries, please feel free to contact us via email address{' '}
            <a
              href='mailto:cs@e.kingsyard.com'
              className={classes.mailto}
            >
              cs@e.kingsyard.com
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default AffiliateProgramPage;
